import ReportsAddressTableItem from './ReportsAddressTableItem'

export default ReportsAddressTableItem
